import Error403 from 'pages/Error/Error403';
import Error404 from 'pages/Error/Error404';
import Error500 from 'pages/Error/Error500';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import eventEmitter from 'utils/eventEmitter';

const ErrorBoundary: React.FC<{children: React.ReactNode}> = ({ children }) => {

    const [error, setError] = useState<{code: number, message: string} | null>(null);

    const location = useLocation();

    useEffect(() => {
        const handleError = (error: {code: number, message: string}) => {
            setError(error);
        }

        eventEmitter.on('error', handleError);

        return () => {
            eventEmitter.off('error', handleError);
        }
    }, [])

    useEffect(() => {
        setError(null);
    }, [location.pathname])



  return (
    <React.Fragment>
        {
            error && [403, 404, 500].includes(error.code) ? (
                <React.Fragment>
                    {
                        error.code === 403 && <Error403 />
                    }
                    {
                        error.code === 404 && <Error404 />
                    }
                    {
                        error.code === 500 && <Error500 />
                    }
                </React.Fragment>
            ) : children
        }
    </React.Fragment>
  )
}

export default ErrorBoundary